import { Component, inject, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { IconComponent } from '@lumio/ui';
import { CookieConsentService } from '../../infrastructure/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [TranslocoPipe, IconComponent],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss',
})
export class CookieConsentComponent {
  private readonly service = inject(CookieConsentService);

  readonly view = signal<'main' | 'preferences'>('main');

  private readonly savedPrefs = this.service.getPreferences();
  readonly analyticsEnabled = signal(this.savedPrefs.analytics);
  readonly marketingEnabled = signal(this.savedPrefs.marketing);

  acceptAll(): void {
    this.service.acceptAll();
  }

  declineAll(): void {
    this.service.declineAll();
  }

  openPreferences(): void {
    this.view.set('preferences');
  }

  goBack(): void {
    this.view.set('main');
  }

  toggleAnalytics(): void {
    this.analyticsEnabled.update((v) => !v);
  }

  toggleMarketing(): void {
    this.marketingEnabled.update((v) => !v);
  }

  savePreferences(): void {
    this.service.saveCustom({
      analytics: this.analyticsEnabled(),
      marketing: this.marketingEnabled(),
    });
  }
}
